import React from "react"
import Layout from "../../../components/shared/layout"
import SEO from "../../../components/shared/seo"

import FeatureHighlights from "../../../components/digital-directory/feature-highlights"
import AdditionalFeatures from "../../../components/digital-directory/additional-features"
import Contact from "../../../components/shared/contact"
import Footer from "../../../components/shared/footer"
import BlogFeatures from "../../../components/digital-directory/blog-features"
import Hero from "../../../components/digital-directory/hero"

export default function DigitalDirectoryPage({ location }) {
  return (
    <Layout location={location}>
      <SEO
        title="Digital Directory Software that Drives Engagement"
        description="Make your indoor space discoverable with state-of-the-art digital directory software from Mappedin. Drive engagement for your indoor space. Book a demo!"
      />
      <Hero />
      <FeatureHighlights />
      <AdditionalFeatures />
      <BlogFeatures />
      <Contact />
      <Footer />
    </Layout>
  )
}
